import React, { useState, useEffect } from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import "./Service.css";
import { useNavigate } from "react-router-dom";


const Service = (props) => {
  const navigate = useNavigate();
  const [selectedBulletIndex, setSelectedBulletIndex] = useState(0);
  const [carousalOffsetStyle, setCarousalOffsetStyle] = useState({});

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 3 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };

    const switchScreen = () => {
      let screenComponent = document.getElementById("ContactMe");
      if (!screenComponent) return;

      screenComponent.scrollIntoView({ behavior: "smooth" });
    };

    const pageRedirection = (pageId) => {
      if(!pageId) {
        alert("Coming soon!");
        return;
      }
      navigate(`/${pageId}`); 
    }

  return (
    <div className="" id={props.id || ""} style={{margin:"120px 0 0 0"}}> 
        <ScreenHeading title={"Services"} />
        <div className="services-container">
            <section id="services" className="services section-bg">
                <div className="" data-aos="fade-up">

                    <div className="section-title">
                    <h2></h2>
                    <p></p>
                    </div>

                    <div className="row">
                        <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
                            <div className="icon-box service-box">
                                <div className="icon" style={{textAlign : "center"}}>
                                    <img src={require("../../assets/Service/astrology.png").default} />
                                </div>
                                <h4 style={{textAlign : "center"}}><a href="">Astrology & Horoscope</a></h4>
                                <p>Unlock the secrets of your future with our expert Astrology and Horoscope services. From personalized predictions to detailed insights into your life's journey, we guide you toward clarity and confidence in every decision.</p>
                                <button style={{marginTop: '20px'}} onClick={() => pageRedirection('astro')} className="btn btn-outline-primary">Know More</button>
                            </div>
                        </div>

                        <div className="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-md-0" data-aos="zoom-in" data-aos-delay="200">
                            <div className="icon-box">
                            <div className="icon" style={{textAlign : "center"}}>
                                    <img src={require("../../assets/Service/location-pin.png").default} />
                            </div>
                            <h4 style={{textAlign : "center"}}><a href="">Vastu Consultant</a></h4>
                            <p>Transform your spaces into hubs of positivity and harmony with our expert Vastu Planning and Consultancy. Achieve balance and prosperity by aligning your home or workplace with ancient Vastu principles.</p>
                            <button style={{marginTop: '20px'}} onClick={() => pageRedirection('vastu')} className="btn btn-outline-primary">Know More</button>
                            </div>
                        </div>

                        <div className="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-xl-0" data-aos="zoom-in" data-aos-delay="300">
                            <div className="icon-box" style={{paddingTop:"30px"}}>
                            <div className="icon" style={{textAlign : "center"}}>
                                    <img src={require("../../assets/Service/gemstone.png").default} />
                            </div>
                            <h4 style={{textAlign : "center"}}><a href="">Buy Gemstones</a></h4>
                            <p>Discover the power of authentic gemstones to enhance your life and balance energies. We provide certified gemstones tailored to your astrological needs for health, success, and prosperity.</p>
                            <button style={{marginTop: '20px'}} onClick={() => pageRedirection('')} className="btn btn-outline-primary">Know More</button>
                            </div>
                        </div>

                        <div className="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-xl-0" data-aos="zoom-in" data-aos-delay="400">
                            <div className="icon-box">
                            <div className="icon" style={{textAlign : "center"}}>
                                    <img src={require("../../assets/Service/hindu-wedding.png").default} />
                            </div>
                            <h4 style={{textAlign : "center"}}><a href="">Marriage Matching</a></h4>
                            <p>Ensure a harmonious and prosperous marriage with our expert Marriage Matching services. Using Vedic astrology, we analyze compatibility and provide insights to help you make informed decisions for a blessed relationship.</p>
                            <button style={{marginTop: '20px'}} onClick={() => pageRedirection('marriage')} className="btn btn-outline-primary">Know More</button>
                            </div>
                        </div>

                    </div>

                </div>
            </section>
        </div>
    </div>
  );
};

export default Service;
